<template>
  <span style="text-align:left">
    <template v-if="modo=='new'||modo=='edit'||modo=='flow'">
      <v-input
        :value="(value)"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <span class="decimalnumber">
          <vue-numeric
            :precision="getComponentParam('precision')||2"
            :currency-symbol-position="getComponentParam('position')||'prefix'"
            :currency="T(getComponentParam('currency')||'R$')"
            :separator="getComponentParam('separator')||'.'"
            :minus="getComponentParam('minus')=='true'?true:false"
            v-bind:value="preLoad(value)"
            v-on:input="(event)=>$emit('input', preUpdate(event))"
          ></vue-numeric>
        </span>
      </v-input>
    </template>

    <template v-if="modo=='list' || modo=='view' || modo=='viewmode'">
      <span
        :class="{'text-xs-center':modo=='list'}"
        v-if="displayvalue && (getComponentParam('position')||'prefix')=='prefix'"
      >{{T(getComponentParam('currency')||'R$')}} {{formatPercent(displayvalue)}}</span>
      <span
        :class="{'text-xs-center':modo=='list'}"
        v-else-if="displayvalue"
      >{{formatPercent(displayvalue)}} {{T(getComponentParam('currency')||'R$')}}</span>
    </template>

    <template v-if="modo=='filtro'">
      <v-input
        hide-details
        :value="(value)"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <span class="decimalnumberfiltro">
          <vue-numeric
            :precision="getComponentParam('precision')||2"
            :currency-symbol-position="getComponentParam('position')||'prefix'"
            :currency="T(getComponentParam('currency')||'R$')"
            :separator="getComponentParam('separator')||'.'"
            :minus="getComponentParam('minus')=='true'?true:false"
            v-bind:value="preLoad(value)"
            v-on:input="(event)=>$emit('input', preUpdate(event))"
          ></vue-numeric>
        </span>
      </v-input>
    </template>
  </span>
</template>
    

<script>
try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
import VueNumeric from "vue-numeric";

export default {
  extends: _baseComponent,

  data() {
    return {};
  },
  methods: {
    preUpdate(myval) {
      return myval == 0 ? 0 : myval;
    },
    formatPercent(value) {
      let val = (value / 1)
        .toFixed(this.getComponentParam("precision") || 2)
        .replace(".", ",");
      return val.toString();
    },
  },
  components: {
    VueNumeric,
  },
};
</script>

<style scoped>
.decimalnumber input {
  font-size: 24px !important;
  height: 42px;
  line-height: 42px;
  background-color: red;
  margin-top: 13px;
  border-bottom: solid #ccc 1px;
  background-color: #fcfcfc;
}
.decimalnumberfiltro input {
  font-size: 18px !important;
  height: 36px;
  line-height: 36px;
  background-color: red;
  border-bottom: solid #ccc 1px;
  background-color: #fcfcfc;
  margin: 2px;
}
</style>

    